(() => {
  'use strict';

  const STORAGE_KEY = 'houseops_contact_submissions';
  const WINDOW_MS = 60 * 60 * 1000;
  const MAX_SUBMISSIONS = 3;
  const MIN_COMPLETION_MS = 2500;

  const disposableDomains = new Set([
    '10minutemail.com', 'guerrillamail.com', 'guerrillamail.net', 'mailinator.com',
    'maildrop.cc', 'sharklasers.com', 'tempmail.com', 'temp-mail.org',
    'throwawaymail.com', 'yopmail.com'
  ]);

  const highRiskPhrases = [
    /first page of google/i,
    /guaranteed google ranking/i,
    /increase (your )?(website )?traffic/i,
    /website redesign service/i,
    /web development service/i,
    /seo (expert|agency|service|specialist)/i,
    /buy backlinks/i,
    /guest post(ing)? opportunity/i,
    /contact me on (whatsapp|telegram)/i,
    /crypto (investment|promotion|marketing)/i
  ];

  const secondarySignals = [
    /backlinks?/i,
    /search engine optimization/i,
    /google ranking/i,
    /website design/i,
    /web design/i,
    /digital marketing/i,
    /lead generation/i,
    /whatsapp/i,
    /telegram/i
  ];

  const now = () => Date.now();

  function getRecentSubmissions() {
    try {
      const timestamps = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(timestamps)
        ? timestamps.filter((timestamp) => Number.isFinite(timestamp) && now() - timestamp < WINDOW_MS)
        : [];
    } catch (_) {
      return [];
    }
  }

  function recordSubmission() {
    try {
      const timestamps = getRecentSubmissions();
      timestamps.push(now());
      localStorage.setItem(STORAGE_KEY, JSON.stringify(timestamps));
    } catch (_) {
      // Storage can be unavailable in private browsing; form submission remains usable.
    }
  }

  function showError(form, message) {
    let error = form.querySelector('[data-houseops-form-error]');
    if (!error) {
      error = document.createElement('div');
      error.dataset.houseopsFormError = 'true';
      error.setAttribute('role', 'alert');
      error.style.cssText = 'margin:12px 0;padding:12px 14px;border:1px solid #c23b22;border-radius:4px;background:#fff5f2;color:#7d2114;font-size:14px;line-height:1.4;';
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.insertAdjacentElement('beforebegin', error);
      else form.appendChild(error);
    }
    error.textContent = message;
    error.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function emailDomain(form) {
    const email = form.querySelector('input[type="email"], input[name*="email" i]');
    const value = email?.value?.trim().toLowerCase() || '';
    return value.includes('@') ? value.split('@').pop() : '';
  }

  function formText(form) {
    return Array.from(form.querySelectorAll('input, textarea, select'))
      .filter((field) => field.type !== 'password' && !field.dataset.houseopsHoneypot)
      .map((field) => String(field.value || ''))
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function protect(form) {
    if (form.dataset.houseopsProtected === 'true') return;
    form.dataset.houseopsProtected = 'true';

    const mountedAt = now();
    const honeypotWrap = document.createElement('div');
    honeypotWrap.setAttribute('aria-hidden', 'true');
    honeypotWrap.style.cssText = 'position:absolute!important;left:-10000px!important;width:1px!important;height:1px!important;overflow:hidden!important;';

    const honeypot = document.createElement('input');
    honeypot.type = 'text';
    honeypot.name = 'contact[company_website]';
    honeypot.tabIndex = -1;
    honeypot.autocomplete = 'off';
    honeypot.dataset.houseopsHoneypot = 'true';
    honeypot.setAttribute('aria-label', 'Leave this field empty');
    honeypotWrap.appendChild(honeypot);
    form.appendChild(honeypotWrap);

    form.addEventListener('submit', (event) => {
      const text = formText(form);
      const links = (text.match(/https?:\/\/|www\./gi) || []).length;
      const secondaryMatches = secondarySignals.filter((pattern) => pattern.test(text)).length;
      const isSolicitation = highRiskPhrases.some((pattern) => pattern.test(text)) || secondaryMatches >= 2;
      const tooFast = now() - mountedAt < MIN_COMPLETION_MS;
      const tooMany = getRecentSubmissions().length >= MAX_SUBMISSIONS;
      const disposable = disposableDomains.has(emailDomain(form));
      const trapped = honeypot.value.trim().length > 0;

      if (trapped || tooFast || tooMany || disposable || isSolicitation || links > 3) {
        event.preventDefault();
        showError(form, 'We could not submit this message. Please remove promotional links, use a permanent email address, and try again in a few minutes.');
        return;
      }

      recordSubmission();
    });
  }

  function scan() {
    document.querySelectorAll('form[action*="/contact"], form[id*="contact" i], form[class*="contact" i]').forEach(protect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
